import {
  getEmployeeLeaveBalances as getEmployeeLeaveBalancesService,
  adjustLeaveBalance as adjustLeaveBalanceService,
  getLeaveAdjustmentHistory as getLeaveAdjustmentHistoryService,
} from "services/company/leaveManagement/leaveAdjustmentReimbursement/leaveAdjustmentReimbursementService";

import {
  fetchBalancesStart,
  fetchBalancesSuccess,
  fetchBalancesFailure,
  fetchHistoryStart,
  fetchHistorySuccess,
  fetchHistoryFailure,
  adjustBalanceStart,
  adjustBalanceSuccess,
  adjustBalanceFailure,
} from "./leaveAdjustmentReimbursementSlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch employee leave balances
export const fetchEmployeeLeaveBalances = () => async (dispatch) => {
  try {
    dispatch(fetchBalancesStart());
    const response = await getEmployeeLeaveBalancesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(fetchBalancesSuccess(response.data || []));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch employee balances";
      dispatch(fetchBalancesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch employee balances";
    dispatch(fetchBalancesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch leave adjustment audit history
export const fetchLeaveAdjustmentHistory = (params = {}) => async (dispatch) => {
  try {
    dispatch(fetchHistoryStart());
    const response = await getLeaveAdjustmentHistoryService(params);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(fetchHistorySuccess(response.data || []));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch adjustment history";
      dispatch(fetchHistoryFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch adjustment history";
    dispatch(fetchHistoryFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Submit leave balance adjustment or reimbursement
export const performLeaveAdjustment = (payload) => async (dispatch) => {
  try {
    dispatch(adjustBalanceStart());
    const response = await adjustLeaveBalanceService(payload);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(adjustBalanceSuccess());
      showSuccessToast(response?.meta?.message || "Leave balance adjusted successfully!");
      // Refresh balances and history
      dispatch(fetchEmployeeLeaveBalances());
      dispatch(fetchLeaveAdjustmentHistory());
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to adjust leave balance";
      dispatch(adjustBalanceFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to adjust leave balance";
    dispatch(adjustBalanceFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
